import { useContext, useState } from 'react'

import { getExtraProperty } from '@tribeplatform/gql-client/lib'
import { useSlateKitContext } from '@tribeplatform/react-slate-kit/hooks'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import {
  CookieConsentPreferencesModal,
  CookieContext,
} from '../Apps/CookieConsent/index.js'
import { PoweredByBettermode } from '../PoweredByBettermode.js'

export const SidebarFooter = () => {
  const slateKitProps = useSlateKitContext()
  const {
    context: { network },
  } = slateKitProps
  const { isCookieInstalled } = useContext(CookieContext)

  const currentYear = new Date().getFullYear()
  const termsOfServiceUrl =
    getExtraProperty(network?.extraProperties, 'termsOfServiceUrl') ??
    network?.termsOfServiceUrl

  const privacyPolicyUrl =
    getExtraProperty(network?.extraProperties, 'privacyPolicyUrl') ??
    network?.privacyPolicyUrl

  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false)

  return (
    <Container
      size="sm"
      spacing="xs"
      padding={{
        disableOnMobile: true,
        top: 'none',
        vertical: 'md',
        horizontal: 'sm',
      }}
      maxSize="sm"
    >
      {!!network?.tribeBranding && (
        <Link
          rel="noopener noreferrer"
          variant="inherit"
          href={`https://bettermode.com/?utm_campaign=powered-by&utm_medium=referral&utm_source=${encodeURIComponent(
            network?.domain,
          )}&utm_term=${encodeURIComponent(network?.name)}`}
          target="_blank"
          className="text-content-on-background-subdued hover:text-content-on-background flex items-start group"
        >
          <PoweredByBettermode />
        </Link>
      )}

      <div className="flex flex-wrap space-s-1 text-xs text-content-on-background-subdued">
        {!!(termsOfServiceUrl || privacyPolicyUrl) && (
          <>
            {!!termsOfServiceUrl && (
              <Link variant="neutral" href={termsOfServiceUrl}>
                Terms
              </Link>
            )}

            {!!termsOfServiceUrl && !!privacyPolicyUrl && <span> · </span>}

            {!!privacyPolicyUrl && (
              <Link variant="neutral" href={privacyPolicyUrl}>
                Privacy
              </Link>
            )}
            <span> · </span>
          </>
        )}
        {isCookieInstalled && (
          <>
            <Link
              as="button"
              variant="neutral"
              onClick={() => setIsCookieModalOpen(true)}
            >
              Cookies
            </Link>
            <span> · </span>
          </>
        )}

        <span aria-label="Copyright">© Copyright {currentYear}</span>
      </div>
      {isCookieModalOpen && (
        <CookieConsentPreferencesModal
          isOpen
          onClose={() => setIsCookieModalOpen(false)}
        />
      )}
    </Container>
  )
}
